/* eslint-disable react-hooks/exhaustive-deps */
import {useEffect, useMemo, useState} from 'react'
import {useIntl} from 'react-intl'
import ToggleButtonForm1 from '../ComponentTab4/ToggleButtonForm1'
import ToggleButtonForm2 from '../ComponentTab4/ToggleButtonForm2'
import ToggleButtonForm3 from '../ComponentTab4/ToggleButtonForm3'
import ToggleButtonForm4 from '../ComponentTab4/ToggleButtonForm4'
import ToggleButtonForm5 from '../ComponentTab4/ToggleButtonForm5'
import ToggleButtonForm6 from '../ComponentTab4/ToggleButtonForm6'
import ToggleButtonform7 from '../ComponentTab4/ToggleButtonform7'
import ToggleButtonForm8 from '../ComponentTab4/ToggleButtonForm8'
import {getListServiceStatus} from '../../core/prestation/request'
import {useAuth} from '../../../../auth'
import {useNavigate, useParams} from 'react-router-dom'
import {useDispatch, useSelector} from 'react-redux'
import {toast} from 'react-toastify'
import {
  setIsThereNonSavedForm,
  setProjectTab4,
  setProjectTab5,
} from '../../../../../common/ModalPopup/reducer'
import {Modal} from 'react-bootstrap'
import {useThemeMode} from '../../../../../../_metronic/partials/layout/theme-mode/ThemeModeProvider'

const NPTab4Form = ({enabled}: {enabled?: boolean}) => {
  const intl = useIntl()
  const {mode} = useThemeMode()
  const navigate = useNavigate()
  const [activeMenu, setActiveMenu] = useState<any>(1)
  const {setAuthMessage, logout} = useAuth()
  const {pGuid} = useParams()
  const dispatch = useDispatch()
  const projectData = useSelector((state: any) => state.projectData)
  const [listService, setListService] = useState<any[]>([])
  const [serviceData, setServiceData] = useState<any>()
  const [serviceDataWithConfirmed, setServiceDataWithConfirmed] = useState<any>()
  const [changeStatus, setChangeStatus] = useState<boolean>(false)
  const [savedStatus, setSavedStatus] = useState<boolean>(false)
  const [showbq, setShowbq] = useState<boolean>(false)
  const [unAuthorized, setUnAuthorized] = useState<boolean>(false)
  const [unAuthorizedMessage, setUnAuthorizedMessage] = useState<string>('Accéss non autorise')
  const [, setW2go] = useState<'tab3' | 'tab5'>('tab3')
  const isThereNonSavedForm = useSelector((state: any) => state?.isThereNonSavedForm)
  useMemo(() => {
    dispatch(setIsThereNonSavedForm(changeStatus))
  }, [changeStatus])

  const customHandleClick = (data: any) => {
    setServiceData(data)
    setActiveMenu(data)
  }

  const loadListServiceStatus = async (isLoadDefault: boolean = false) => {
    const response = await getListServiceStatus(
      pGuid || projectData?.tab1?.data?.Guid || '',
      (message: string) => {
        setAuthMessage(message)
        logout()
      },
      ({Message, MessageType, Toast, ToastType}) => {
        if (Message && MessageType === 'Success') {
          //
        } else if (Message && MessageType === 'Error') {
          //
        } else if (Toast && ToastType === 'Success') {
          toast(Toast, {type: 'success'})
        } else if (Toast && ToastType === 'Error') {
          toast(Toast, {type: 'error'})
        }
      }
    )

    if (response?.data && response?.data?.data && Array.isArray(response?.data?.data)) {
      setListService(response?.data?.data)
      if (response?.data?.data?.length > 0 && isLoadDefault) {
        setServiceData(response?.data?.data[0])
      }
      if (Array.isArray(response?.data?.data) && !isLoadDefault) {
        if (
          //serviceData?.Code == "T001"
          // && serviceData?.Completed &&
          serviceData?.Enabled
        ) {
          const index = response?.data?.data.findIndex(
            (option) => option.Code === serviceData?.Code
          ) //"T001")
          if (index !== -1 && index + 1 < response?.data?.data.length) {
            const serviceDataItem = response?.data?.data[index + 1]
            if (serviceDataItem?.Enabled) {
              setServiceData(serviceDataItem || {})
            } else {
              setUnAuthorized(true)
              setUnAuthorizedMessage(
                "Vous n'avez pas répondu à toutes les questions, vous devez le faire avant de passer à l'étape suivante"
              )
            }
          }
        }
      }
    }
  }

  useEffect(() => {
    if (enabled) loadListServiceStatus(true)
  }, [enabled])

  console.log('store', isThereNonSavedForm)

  return (
    <div className='p-5'>
      <div className='gap-5 d-lg-flex d-md-flex d-xl-flex flex-sm-column flex-xl-row flex-lg-row flex-md-row justify-content-xl-between justify-content-lg-between justify-content-md-between align-items-start justify-content-md-between justify-content-sm-start flex-1'>
        {Array.isArray(listService) && listService.length > 0 && (
          <div
            className='rounded border-4 p-2'
            style={{
              backgroundColor: '#636E72',
              flex: 0.35,
            }}
          >
            {listService.map((service: any, key) => {
              return (
                <>
                  <div
                    key={key}
                    className='p-2'
                    onClick={() => {
                      if (service?.Enabled) {
                        if (changeStatus && service?.Code !== serviceData?.Code) {
                          setShowbq(true)
                          setServiceDataWithConfirmed(service)
                          return
                        }
                        customHandleClick(service)
                        setActiveMenu(key + 1)
                      } else {
                        setUnAuthorized(true)
                        setUnAuthorizedMessage('Accès non autorisé')
                      }
                    }}
                    style={{
                      cursor: 'pointer',
                      backgroundColor: service?.Code === serviceData?.Code ? '#95a5a6' : '#636E72',
                    }}
                  >
                    <div className='d-flex flex-row align-items-center gap-3'>
                      <div
                        className='d-flex justify-content-center align-items-center rounded-pill '
                        style={{
                          backgroundColor: service?.Completed ? '#BADC58' : '#2D3436',
                          width: 30,
                          height: 30,
                        }}
                      >
                        {service?.Completed && (
                          <i
                            style={{color: 'red'}}
                            className='fa-solid fa-check text-light fs-4'
                          ></i>
                        )}
                      </div>
                      <div
                        className={
                          service?.Completed
                            ? 'fs-5 fw-bolder text-light'
                            : 'fs-5 fst-italic text-dark'
                        }
                        style={{cursor: 'pointer'}}
                      >
                        {service?.Title}
                      </div>
                    </div>
                    <div className='d-flex separator border-3 border-secondary ' />
                  </div>
                </>
              )
            })}
          </div>
        )}
        <div
          style={{flex: 0.65}}
          className='bg-secondary rounded border-4 my-5 my-sm-5 my-md-0 my-lg-0 my-xl-0'
        >
          <div>
            {serviceData?.Code === 'T001' && (
              <ToggleButtonForm1
                isVisible={true}
                onDetectChange1={(ischange1) => setChangeStatus(!ischange1)}
                listeService={listService}
                setListService={setListService}
                itemProps={activeMenu}
                setServiceData={setServiceData}
                t001={serviceData}
                loadListServiceStatus={loadListServiceStatus}
                onSavedForm={(saved) => {
                  setChangeStatus(false)
                  setSavedStatus(saved)
                }}
              />
            )}
          </div>
          <div>
            {serviceData?.Code === 'T002' && (
              <ToggleButtonForm2
                isVisible1={true}
                onDetectChange2={(ischange2) => setChangeStatus(!ischange2)}
                listeService={listService}
                setListService={setListService}
                itemProps={activeMenu}
                setServiceData={setServiceData}
                onSavedForm={(saved) => {
                  setChangeStatus(false)
                  setSavedStatus(saved)
                }}
                t002={serviceData}
                loadListServiceStatus={loadListServiceStatus}
              />
            )}
          </div>
          <div>
            {serviceData?.Code === 'T003' && (
              <ToggleButtonForm3
                isVisible2={true}
                onDetectChange3={(ischange3) => setChangeStatus(!ischange3)}
                listeService={listService}
                setListService={setListService}
                itemProps={activeMenu}
                setServiceData={setServiceData}
                onSavedForm={(saved) => {
                  setChangeStatus(false)
                  setSavedStatus(saved)
                }}
                t003={serviceData}
                loadListServiceStatus={loadListServiceStatus}
              />
            )}
          </div>
          <div>
            {serviceData?.Code === 'T004' && (
              <ToggleButtonForm4
                isVisible3={true}
                onDetectChange4={(ischange4) => setChangeStatus(!ischange4)}
                listeService={listService}
                setListService={setListService}
                itemProps={activeMenu}
                setServiceData={setServiceData}
                onSavedForm={(saved) => {
                  setChangeStatus(false)
                  setSavedStatus(saved)
                }}
                t004={serviceData}
                loadListServiceStatus={loadListServiceStatus}
              />
            )}
          </div>
          <div>
            {serviceData?.Code === 'T005' && (
              <ToggleButtonForm5
                isVisible4={true}
                onDetectChange3={(isChange5) => setChangeStatus(!isChange5)}
                listeService={listService}
                setListService={setListService}
                itemProps={activeMenu}
                setServiceData={setServiceData}
                onSavedForm={(saved) => {
                  setChangeStatus(false)
                  setSavedStatus(saved)
                }}
                t005={serviceData}
                loadListServiceStatus={loadListServiceStatus}
              />
            )}{' '}
          </div>
          <div>
            {serviceData?.Code === 'T006' && (
              <ToggleButtonForm6
                isVisible5={true}
                onDetectChange6={(isChange6) => setChangeStatus(!isChange6)}
                listeService={listService}
                setListService={setListService}
                itemProps={activeMenu}
                setServiceData={setServiceData}
                onSavedForm={(saved) => {
                  setChangeStatus(false)
                  setSavedStatus(saved)
                }}
                t006={serviceData}
                loadListServiceStatus={loadListServiceStatus}
              />
            )}
          </div>
          <div>
            {serviceData?.Code === 'T007' && (
              <ToggleButtonform7
                isVisible6={true}
                onDetectChange7={(isChange7) => setChangeStatus(!isChange7)}
                listeService={listService}
                setListService={setListService}
                itemProps={activeMenu}
                setServiceData={setServiceData}
                onSavedForm={(saved) => {
                  setChangeStatus(false)
                  setSavedStatus(saved)
                }}
                t007={serviceData}
                loadListServiceStatus={loadListServiceStatus}
              />
            )}
          </div>
          <div>
            {serviceData?.Code === 'T008' && (
              <ToggleButtonForm8
                onDetectChangeForm={(ischange1) => setChangeStatus(!ischange1)}
                isVisible7={true}
                loadListServiceStatus={loadListServiceStatus}
                t008={serviceData}
              />
            )}
          </div>
        </div>
      </div>

      <div className='d-flex gap-2 justify-content-between my-xl-5 my-lg-5 my-md-5'>
        <span className={'cursor-pointer'}>
          <button
            type='button'
            className='btn btn-secondary flex-column'
            onClick={() => {
              setW2go('tab3')
              if (changeStatus) {
                setShowbq(true)
              } else {
                navigate('/new-project/tab3' + (pGuid ? '/' + pGuid : ''))
              }
              // console.log('change status :', changeStatus)
            }}
          >
            <i className='ki-duotone ki-arrow-left fs-1'>
              <span className='path1'></span>
              <span className='path2'></span>
            </i>
            {intl.formatMessage({id: 'BUTTON.BACK'})}
          </button>
        </span>
        <span className={'' + (!pGuid && !savedStatus ? 'not-allowed' : ' cursor-pointer ')}>
          <button
            type='submit'
            className='btn btn-secondary flex-column'
            disabled={!pGuid && !savedStatus}
            onClick={() => {
              setW2go('tab5')
              if (changeStatus) {
                setShowbq(true)
              } else {
                if (!pGuid && !savedStatus) {
                  //
                } else {
                  if (!pGuid) {
                    dispatch(
                      setProjectTab4({
                        data: null,
                        disabled: false,
                        active: false,
                      })
                    )
                    dispatch(
                      setProjectTab5({
                        data: null,
                        disabled: false,
                        active: true,
                      })
                    )
                  }
                  navigate('/new-project/tab5' + (pGuid ? '/' + pGuid : ''))
                }
              }
              // console.log('change status :', changeStatus)
            }}
          >
            {intl.formatMessage({id: 'SUIVANT'})}
            <i className='ki-duotone ki-arrow-right fs-1'>
              <span className='path1'></span>
              <span className='path2'></span>
            </i>
          </button>
        </span>
      </div>
      <Modal show={showbq} centered>
        <div className='text-center p-5 w-100' data-bs-theme={mode}>
          <div
            className={'w-100 rounded ' + (mode === 'dark' ? ' bg-none ' : ' bg-white ')}
            data-bs-theme={mode}
          >
            <div className='d-flex align-items-center justify-content-between'>
              <div className='fw-bolder text-gray-700 py-3'>
                {intl.formatMessage({id: 'INFORMATION'})}
              </div>
              <div
                className='p-1 cursor-pointer'
                onClick={() => {
                  setShowbq(false)
                }}
              >
                <i className='fa fa-close text-danger'></i>
              </div>
            </div>
            <div className={'text-start py-3'}>
              <div>{intl.formatMessage({id: 'BEFORE_QUIT_CONFIRM_MESSAGE'})}</div>
            </div>
            <div className='d-flex align-items-center justify-content-evenly'>
              <button
                className={'btn btn-secondary'}
                onClick={() => {
                  setShowbq(false)
                }}
              >
                {intl.formatMessage({id: 'NO'})}
              </button>
              <button
                className={'btn btn-primary'}
                onClick={() => {
                  /* if (!pGuid) {
                    dispatch(
                      setProjectTab4({
                        data: null,
                        disabled: false,
                        active: false,
                      })
                    )
                    dispatch(
                      setProjectTab5({
                        data: null,
                        disabled: false,
                        active: true,
                      })
                    )
                  }*/
                  // navigate('/new-project/' + w2go + (pGuid ? '/' + pGuid : ''))
                  setChangeStatus(false)
                  setShowbq(false)
                  setServiceData(serviceDataWithConfirmed)
                }}
              >
                {intl.formatMessage({id: 'YES'})}
              </button>
            </div>
          </div>
        </div>
      </Modal>
      <Modal show={unAuthorized} centered>
        <div className='text-center p-5 w-100' data-bs-theme={mode}>
          <div
            className={'w-100 rounded ' + (mode === 'dark' ? ' bg-none ' : ' bg-white ')}
            data-bs-theme={mode}
          >
            <div className='d-flex align-items-center justify-content-between'>
              <div className='fw-bolder text-gray-700 py-3'>
                {intl.formatMessage({id: 'INFORMATION'})}
              </div>
              <div
                className='p-1 cursor-pointer'
                onClick={() => {
                  setUnAuthorized(false)
                }}
              >
                <i className='fa fa-close text-danger'></i>
              </div>
            </div>
            <div className={'text-center py-3 justify-content-center'}>
              <div>{unAuthorizedMessage}</div>
            </div>
            <div className='d-flex align-items-center justify-content-center'>
              <button
                className={'btn btn-primary'}
                onClick={() => {
                  setUnAuthorized(false)
                }}
              >
                J'ai compris
              </button>
            </div>
          </div>
        </div>
      </Modal>
      {/* <Modal show={showCancel} centered>
        <div className='text-center p-5 w-100' data-bs-theme={mode}>
          <div
            className={'w-100 rounded ' + (mode === 'dark' ? ' bg-none ' : ' bg-white ')}
            data-bs-theme={mode}
          >
            <div className='d-flex align-items-center justify-content-between'>
              <div className='fw-bolder text-gray-700 py-3'>
                {intl.formatMessage({id: 'INFORMATION'})}
              </div>
              <div className='p-1 cursor-pointer' onClick={onCancelReset}>
                <i className='fa fa-close text-danger'></i>
              </div>
            </div>
            <div className={'text-start py-3'}>
              <div>{intl.formatMessage({id: 'RESET_CONFIRM_MESSAGE'})}</div>
            </div>
            <div className='d-flex align-items-center justify-content-evenly'>
              <button className={'btn btn-secondary'} onClick={onCancelReset}>
                {intl.formatMessage({id: 'NO'})}
              </button>
              <button className={'btn btn-primary'} onClick={onConfirmCancel}>
                {intl.formatMessage({id: 'YES'})}
              </button>
            </div>
          </div>
        </div>
      </Modal> */}
    </div>
  )
}

export default NPTab4Form
